import { createHydratedReducer } from '@store/_abstract/hydrated';

import {
  CART_FUNNEL_STORE_API_PIECE,
  CART_FUNNEL_STORE_FUNNEL_PIECE,
  CART_FUNNEL_STORE_HYDRATION_PIECE,
  CART_FUNNEL_STORE_LOCAL_PIECE,
} from './cart-funnel.piece';
import {
  CART_FUNNEL_STORE_INITIAL_STATE,
  CART_FUNNEL_STORE_KEY,
  CartFunnelState,
} from './cart-funnel.state';

export const CART_FUNNEL_STORE_REDUCER = createHydratedReducer<CartFunnelState>({
  key: CART_FUNNEL_STORE_KEY,
  initialState: CART_FUNNEL_STORE_INITIAL_STATE,
  properties: ['activeCartId', 'orderComment', 'funnelUsername', 'seatCount', 'values'],
  ons: [
    ...CART_FUNNEL_STORE_HYDRATION_PIECE,
    ...CART_FUNNEL_STORE_FUNNEL_PIECE,
    ...CART_FUNNEL_STORE_API_PIECE,
    ...CART_FUNNEL_STORE_LOCAL_PIECE,
  ],
});
